/**
 * Generated by orval v8.0.0-rc.0 🍺
 * Do not edit manually.
 */
import type {
  AuthV1AdminLoginReq,
  AuthV1AdminLoginRes,
  AuthV1AdminLogoutReq,
  AuthV1AdminLogoutRes,
  AuthV1AdminTokenRefreshReq,
  AuthV1AdminTokenRefreshRes,
  AuthV1AdminUpdatePasswordReq,
  AuthV1AdminUpdatePasswordRes,
  AuthV1AdminUserInfo
} from './models';

import { customInstance } from '../mutator';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getAdminAuth = () => {
/**
 * @summary 管理员登录
 */
const adminLogin = (
    authV1AdminLoginReq: AuthV1AdminLoginReq,
 options?: SecondParameter<typeof customInstance<AuthV1AdminLoginRes>>,) => {
      return customInstance<AuthV1AdminLoginRes>(
      {url: `/v1/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authV1AdminLoginReq
    },
      options);
    }
  /**
 * @summary 管理员登出
 */
const adminLogout = (
    authV1AdminLogoutReq: AuthV1AdminLogoutReq,
 options?: SecondParameter<typeof customInstance<AuthV1AdminLogoutRes>>,) => {
      return customInstance<AuthV1AdminLogoutRes>(
      {url: `/v1/auth/logout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authV1AdminLogoutReq
    },
      options);
    }
  /**
 * @summary 修改密码
 */
const adminUpdatePassword = (
    authV1AdminUpdatePasswordReq: AuthV1AdminUpdatePasswordReq,
 options?: SecondParameter<typeof customInstance<AuthV1AdminUpdatePasswordRes>>,) => {
      return customInstance<AuthV1AdminUpdatePasswordRes>(
      {url: `/v1/auth/password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: authV1AdminUpdatePasswordReq
    },
      options);
    }
  /**
 * @summary 获取当前管理员信息
 */
const adminGetProfile = (
    
 options?: SecondParameter<typeof customInstance<AuthV1AdminUserInfo>>,) => {
      return customInstance<AuthV1AdminUserInfo>(
      {url: `/v1/auth/profile`, method: 'GET'
    },
      options);
    }
  /**
 * @summary 刷新访问令牌
 */
const adminTokenRefresh = (
    authV1AdminTokenRefreshReq: AuthV1AdminTokenRefreshReq,
 options?: SecondParameter<typeof customInstance<AuthV1AdminTokenRefreshRes>>,) => {
      return customInstance<AuthV1AdminTokenRefreshRes>(
      {url: `/v1/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authV1AdminTokenRefreshReq
    },
      options);
    }
  return {adminLogin,adminLogout,adminUpdatePassword,adminGetProfile,adminTokenRefresh}};
export type AdminLoginResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminLogin']>>>
export type AdminLogoutResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminLogout']>>>
export type AdminUpdatePasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminUpdatePassword']>>>
export type AdminGetProfileResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminGetProfile']>>>
export type AdminTokenRefreshResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminTokenRefresh']>>>
